// angular
// 	.module("HeroPRO")
// 	.factory("PipelineFactory", PipelineFactory);

import _ from 'lodash';

/* @ngInject */
export default function PipelineFactory($http, $location, $q, HPConfig) {
    let pipelineState = {};

    let pipelineDataOptions = {
    // sort: {},
    // filterOptions: {}
    };

    const pipelineFilterItems = [];

    const pipelineStages = [{
        name: 'Leads',
        pipelineStageName: 'leads',
        pipelineStageId: 1,
    },
    {
        name: 'Application',
        pipelineStageName: 'application',
        pipelineStageId: 2,
    },
    {
        name: 'Start Work',
        pipelineStageName: 'startwork',
        pipelineStageId: 3,
    },
    {
        name: 'Get Paid',
        pipelineStageName: 'getpaid',
        pipelineStageId: 4,
    },
    {
        name: 'Closed',
        pipelineStageName: 'closed',
        pipelineStageId: 5,
    },
    ];

    const pipelineVisibilityFilters = [{
        filterId: 1,
        filterName: 'All Projects',
        selected: false,
    },
    {
        filterId: 2,
        filterName: 'Active Projects',
        selected: true,
    },
    {
        filterId: 3,
        filterName: 'Hidden Projects',
        selected: false,
    },
    ];

    return {
        getPipelineLoanData,
        getPipelineLeadData,
        getPipelineStages,
        setPipelineDataOptions,
        getPipelineDataOptions,
        clearPipelineDataOption,
        clearPipelineDataOptions,
        clearPipelineDataOptionsExcept,
        pipelineFilterItems,
        pipelineVisibilityFilters,
        getAdvancePaymentData,
        getPipelineState,
    };

    function clearPipelineDataOption(optionName) {
        pipelineDataOptions = _.omit(pipelineDataOptions, optionName);
    }

    function clearPipelineDataOptionsExcept(key) {
        pipelineDataOptions = _.pick(pipelineDataOptions, key);
    }

    function clearPipelineDataOptions() {
        pipelineDataOptions = {};
    }

    function setPipelineDataOptions(options) {
        _.extend(pipelineDataOptions, options);
    }

    function getPipelineDataOptions() {
        return pipelineDataOptions;
    }

    function getPipelineLeadData() {
        const defaultPipelineLeadDataOptions = {
            LocationContractorId: null,
            PageSize: '20',
            PageNumber: '0',
            sortOptions: {
                SortOrderID: 1, // 1 = Descending, 2 = Ascending
                SortColumnId: 8, // 8 = Date
            },
        };

        pipelineDataOptions = _.omit(pipelineDataOptions, 'PipelineStageId');

        const data = angular.extend({}, defaultPipelineLeadDataOptions, (pipelineDataOptions || {}));

        setPipelineState(data);

        const promise = $http({
            url: `${HPConfig.heroProApi}KBYG/Pipeline/Get`,
            method: 'POST',
            data,
        });

        heroProbeLead(promise);

        return promise;
    }

    function getPipelineLoanData() {
        const defaultPipelineLoanDataOptions = {
            LocationContractorId: null,
            PageSize: '20',
            PageNumber: '0',
            sortOptions: {
                SortOrderID: 1, // 1 = Descending, 2 = Ascending
                SortColumnId: (pipelineDataOptions.PipelineStageId === 5) ? 9 : 8, // 9 = FundDate, 8 = Date
            },
        };

        const data = angular.extend({}, defaultPipelineLoanDataOptions, (pipelineDataOptions || {}));

        setPipelineState(data);

        const promise = $http({
            url: `${HPConfig.heroProApi}Loan/FundingRequest/Pipeline`,
            method: 'POST',
            data,
        });

        heroProbeLoan(promise);

        return promise;
    }

    function getAdvancePaymentData(params) {
        return $http.get(`${HPConfig.heroProApi}Loan/FundingRequest/Pipeline/AdvancePayments`, {
            params,
        });
    }

    function getPipelineStages() {
        return pipelineStages;
    }

    function setPipelineState(data) {
        pipelineState = {};
        _.extend(pipelineState, data);
    }

    function getPipelineState() {
        return pipelineState;
    }

    // heroProbe
    function heroProbeLoan(promise) {
        if ($location.search().heroprobe !== undefined) {
            promise.then((response) => {
                console.table(response.data.Data.PipelineFundingRequests, ['Owner1FirstName', 'Owner1LastName', 'FundingRequestId', 'LoanStateId', 'FundingRequestStateId',
                    'FinDocsStateId', 'PipelineStageId', 'FundingRequestPipelineStageId',
                ]);
            });
        }
    }

    function heroProbeLead(promise) {
        if ($location.search().heroprobe !== undefined) {
            promise.then((response) => {
                console.table(response.data.Data.PipelineKBYGs, ['Address', 'City', 'PreQualId', 'Status', 'ApprovedAmount', 'LeadSource']);
            });
        }
    }

    // heroProbe
}



// WEBPACK FOOTER //
// ./src/app/pipeline/pipelineFactory.js